import { useAssign } from "Hooks/basic"
import { ApplyData, useApplyPreest } from "Hooks/preset"
import { useErrorCallback } from "Components/Preset/Modal/hook"
import { useContext } from "react"
import { AppContext } from "Views/Home/context"
import { InitialModal } from "Methods/modal"

let applyLock = false
export function useCalendarTool() {
    const { object: data, handleChange: setData } = useAssign<ApplyData|null>(null)
    const { apply } = useApplyPreest()
    const { handleError } = useErrorCallback()
    const { handleChangeModal } = useContext(AppContext)
    const cancel = () => {}
    const handleCreate = async () => {
        if (applyLock) {
            return
        }
        applyLock = true
        if (!data) {
            return
        }
        try {
            await apply(data)
            handleChangeModal({
                show: true,
                type: "success",
                title: "母版生成中，生成结果稍后将发送到您的邮箱，两次生成操作需要间隔至少1分钟。",
                timeout: 5000,
                customButtons: [],
                onConfirm: () => {
                    handleChangeModal(InitialModal)
                },
            })
        } catch (err) {
            handleError(cancel, err)
        } finally {
            applyLock = false
        }
    }
    const disabled = !data || !data.start_at || !data.end_at
    return {
        handleCreate, setData, disabled,
    }
}
